import React, { useEffect, useState } from 'react';
import { useForm, FieldValues } from 'react-hook-form';
import ClayLayout from '@clayui/layout';
import { Button } from '@clayui/core';
import Loader from '../../../generic-components/loader/Loader';
import FormComponent from '../../../generic-components/formComponent/FormComponent';
import { attractionBasicDetailsFields1, attractionBasicDetailsFields2, scopeKeyLeadManagement } from '../../../utils/Config';
import './AttractionBasicDetail.css';
import { expansionInquiryService } from '../../../services/expansionInquiryService';
import { otpService } from '../../../services/otpService';
import { toast } from 'react-toastify';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { updateCommonValues } from '../../../slices/commonSlice';
import { 
    updateAttractionBasicDetailValues, 
    resetAttractionBasicDetail 
} from '../../../slices/attractionBasicDetailSlice';
const AttractionBasicDetail: React.FC<{
    setStep: React.Dispatch<React.SetStateAction<number>>;
    onLoadingChange?: (loading: boolean) => void;
}> = ({ setStep, onLoadingChange }) => {
    const dispatch = useAppDispatch();
    const attractionBasicDetail = useAppSelector((state) => state.attractionBasicDetail);
    const common = useAppSelector((state) => state.common);

    const {
        control,
        register,
        formState: { errors: formErrors, touchedFields },
        watch,
        handleSubmit,
        setError,
        clearErrors,
        setValue
    } = useForm<FieldValues>({ 
        mode: 'all',
        defaultValues: {
            companyName: attractionBasicDetail.companyName,
            contactName: attractionBasicDetail.contactName,
            designation: attractionBasicDetail.designation,
            phoneNumber: attractionBasicDetail.phoneNumber,
            website: attractionBasicDetail.website,
            businessEmail: common.businessEmail || '',
        }
    });

    const [dropdownOptions, setDropdownOptions] = useState<any>({});

    const primaryButtonStyle: React.CSSProperties = {
        '--bg-cut-background': '#ffffff'
    } as React.CSSProperties;

    const onSubmit = async (data: any) => {
        // Show loader
        onLoadingChange?.(true);
        
        // Save businessEmail to common slice (existing behavior)
        dispatch(updateCommonValues({ businessEmail: data?.businessEmail }));
        
        // Save other fields to attractionBasicDetail slice
        dispatch(updateAttractionBasicDetailValues({
            companyName: data?.companyName || '',
            contactName: data?.contactName || '',
            designation: data?.designation || '',
            phoneNumber: data?.phoneNumber || '',
            website: data?.website || '',
        }));

        try {
            const response = await otpService.gerateOTP(
                data?.businessEmail,
                scopeKeyLeadManagement
            );
            if (response.statusCode === 200) {
                toast.success(response.statusMessage, {
                    theme: 'light',
                    autoClose: 2000
                });
                setStep(1);
            }
        } catch (err: any) {
            toast.error(err?.message || 'Failed to submit inquiry', {
                theme: 'light',
                autoClose: 4000
            });
        } finally {
            // Hide loader
            onLoadingChange?.(false);
        }
    };

    // Watch form changes and persist to Redux
    const formValues = watch();
    useEffect(() => {
        if (formValues.companyName !== undefined) {
            dispatch(updateAttractionBasicDetailValues({
                companyName: formValues.companyName || '',
                contactName: formValues.contactName || '',
                designation: formValues.designation || '',
            }));
        }
    }, [formValues.companyName, formValues.contactName, formValues.designation, dispatch]);

   
    

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)}>
                <ClayLayout.Row justify="start" className="basic_detail_form">
                    {attractionBasicDetailsFields1.map((field) => (
                        <ClayLayout.Col
                            key={field.name}
                            xl={6}
                            lg={6}
                            md={6}
                            sm={6}
                            xs={12}
                        >
                            <FormComponent
                                {...field}
                                register={register}
                                control={control}
                                errors={formErrors}
                                watch={watch}
                                setError={setError}
                                errorTitle={field.errorMessage}
                                options={
                                    dropdownOptions[field.name] || []
                                }
                            />
                        </ClayLayout.Col>
                    ))}
                </ClayLayout.Row>
                <h2 className="section-title">
                    Point of Contact Details:
                </h2>
                <ClayLayout.Row justify="start" className="basic_detail_form">
                    {attractionBasicDetailsFields2.map((field) => (
                        <ClayLayout.Col
                            key={field.name}
                            xl={6}
                            lg={6}
                            md={6}
                            sm={6}
                            xs={12}
                        >
                            <FormComponent
                                {...field}
                                register={register}
                                control={control}
                                errors={formErrors}
                                watch={watch}
                                setError={setError}
                                errorTitle={field.errorMessage}
                                options={
                                    dropdownOptions[field.name] || []
                                }
                            />
                        </ClayLayout.Col>
                    ))}
                </ClayLayout.Row>

                <div className="submit-button-container">
                    <Button
                        type="submit"
                        className="bottom-cut"
                        style={primaryButtonStyle}
                    >
                        <span className="bottom-cut-span"></span>
                        Continue
                    </Button>
                </div>
            </form>
        </>

    );
};

export default AttractionBasicDetail;
